/**
 * FollowUpsPage - Main page for follow-ups list
 */

import React from "react";
import { Box, Container } from "@mui/material";
import FollowUpList from "../components/FollowUpList.jsx";

/**
 * FollowUpsPage Component
 */
const FollowUpsPage = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <FollowUpList />
    </Container>
  );
};

export default FollowUpsPage;

